import { NgModule } from '@angular/core';
import { Ionic4EmojiPickerComponent } from './ionic4-emoji-picker.component';
import {IonicModule} from '@ionic/angular';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [Ionic4EmojiPickerComponent],
  entryComponents:[Ionic4EmojiPickerComponent],
  imports: [
    CommonModule,
    IonicModule.forRoot()
  ],
  exports: [Ionic4EmojiPickerComponent]
})
export class Ionic4EmojiPickerModule { }
